import React, { useEffect } from "react";
import { ListGroup,ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";

const SubCat = ({ cat, setCat }) => {
  const [subCatData, setSubCatData] = React.useState([]);
  let category = window.location.href.split("/")[4].split('-').join(' ');


  useEffect(() => {
    const filteredCat = cat.filter(
      (item) => item.parentCat === unescape(category)
    );
    const childCat = filteredCat.map((item) => item.childCat);
    setSubCatData(childCat);
  }, [cat]);
 if(subCatData[0]&& subCatData[0].toString().trim() === "") return(
   // not found
    <div className="container">
        <div className="row">
            <div className="col-md-12 my-5">
                <div className="alert alert-danger" role="alert">
                    <p className="text-center">No SubCategory Found</p>
                </div>

            </div>
        </div>
    </div>

 )
  return (
    <div className="container my-5 bg-white dtable">
    <div className="mb-5">
      <div className="my-3 py-4">
        <p className="text-center px-3">
          A list of niche Web directories on the internet. If you want
          your niche directory added to this list send a payment of $179
          to webmaster@directoryfire.com via paypal and it will be
          reviewed.
        </p>
      </div>
      {/* <Table data={nicheDirectories}/> */}
      <ListGroup>
        <div className="row mx-5">
          {subCatData && subCatData[0]&&
            subCatData[0].map((item, i) => (
              <ListGroupItem key={i} variant="flush" className="col-6" as='a'>
                <Link to={`/sub-niche/child-cat/${item.split(' ').join('-')}`}>
                  {item}
                </Link>
              </ListGroupItem>
            ))}
        </div>
      </ListGroup>
      ;
    </div>
  </div>
    
  )
};

export default SubCat;
